import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import classNames from 'classnames';
import Divider from '../divider';
import Tooltip from '../tooltip';
import TextLabel from '../textLabel';
import RadioButton from '../radioButton';

var VerticalTabsCustom = /*#__PURE__*/function (_React$Component) {
  _inherits(VerticalTabsCustom, _React$Component);

  var _super = _createSuper(VerticalTabsCustom);

  function VerticalTabsCustom() {
    var _this;

    _classCallCheck(this, VerticalTabsCustom);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "repeatOption", function (selectedValue, option) {
      return /*#__PURE__*/React.createElement("div", {
        key: 'option-' + option.value,
        className: "tab",
        "data-hook": option.dataHook
      }, /*#__PURE__*/React.createElement(Tooltip, {
        disabled: _this.props.closed,
        content: option.label,
        alignment: "RIGHT",
        closeOnMouseClick: true
      }, /*#__PURE__*/React.createElement("label", {
        name: 'radio_' + option.value,
        className: "tabLabel"
      }, /*#__PURE__*/React.createElement(RadioButton, {
        value: option.value,
        selected: option.value === selectedValue,
        onChange: function onChange() {
          return _this.props.onChange(option.value);
        },
        showRadioSymbol: false,
        name: option.value
      }, /*#__PURE__*/React.createElement("span", {
        className: "tab-icon-text-wrapper"
      }, option.symbol ? /*#__PURE__*/React.createElement("span", {
        key: "icon",
        className: "tab-icon"
      }, option.symbol) : null, _this.props.closed ? /*#__PURE__*/React.createElement("span", {
        className: "tab-text",
        key: "verticalTabCustomText"
      }, /*#__PURE__*/React.createElement(TextLabel, {
        value: option.label,
        type: "T19"
      })) : null)), _this.props.closed ? /*#__PURE__*/React.createElement(Divider, {
        "long": true,
        key: "divider"
      }) : null)));
    });

    return _this;
  }

  _createClass(VerticalTabsCustom, [{
    key: "render",
    value: function render() {
      var _this$props$options,
          _this2 = this;

      var selectedValue = this.props.value;
      var classes = {
        'control-tabs-vertical-custom': true,
        closed: this.props.closed
      };
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(classes),
        "data-hook": this.props.dataHook
      }, (_this$props$options = this.props.options) === null || _this$props$options === void 0 ? void 0 : _this$props$options.map(function (opt) {
        return _this2.repeatOption(selectedValue, opt);
      }));
    }
  }]);

  return VerticalTabsCustom;
}(React.Component);

VerticalTabsCustom.displayName = 'VerticalTabs';
VerticalTabsCustom.propTypes = {
  /** current tab value */
  value: PropTypes.string,

  /** a callback called on tab click with the newly selected option's `value` */
  onChange: PropTypes.func.isRequired,

  /** close tooltip and show tab lable next to its symbol */
  closed: PropTypes.bool.isRequired,

  /** list of all tab options */
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    symbol: PropTypes.node.isRequired,
    dataHook: PropTypes.string
  })),
  dataHook: PropTypes.string
};
export default compose(VerticalTabsCustom);